/**
 * The seat check said "full" when the meeting link opened.
 *
 * `MeetingGuard` asks the server whether this person could join before the
 * prejoin preview is shown. A full meeting used to end there, with a toast and
 * a trip back to the dashboard. It now goes on to the preview, which says the
 * meeting is full in a dialog and lets them try again from where they are, so
 * the guard has to tell VcApp what the server told it.
 *
 * Module state, like `guest-password.ts`, for the same reason: it crosses the
 * moment between the guard's check and VcApp mounting, nothing renders from
 * it, and it should not be persisted anywhere.
 */
let fullAt: string | null = null

export function noteMeetingFull(meetingId: string): void {
  fullAt = meetingId
}

/** Whether the guard found this meeting full. */
export function wasMeetingFull(meetingId: string): boolean {
  return fullAt === meetingId
}

/** Once VcApp has read it, or the guard checks again. */
export function clearMeetingFull(): void {
  fullAt = null
}
